module.exports = __webpack_public_path__ + "static/media/s5.4fcd7fdd.png";